
export default function Angebote() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="angebote" className="py-32 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 mb-6 tracking-tight">
            Unsere Angebote
          </h2>
          <p className="text-base md:text-lg text-gray-600 font-light max-w-2xl mx-auto leading-relaxed">
            Wählen Sie zwischen klassischer Eleganz und unvergesslichem Live-Erlebnis
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Karte 1 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group">
            <div className="relative h-80 overflow-hidden">
              <img 
                src="https://public.readdy.ai/ai/img_res/22382b61a4534fe9b5b9ba2e3fc3e65a.jpg" 
                alt="Die klassische Pasta-Bar" 
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            <div className="p-10">
              <h3 className="font-serif text-3xl text-gray-900 mb-4 tracking-tight">
                Die klassische Pasta-Bar
              </h3>
              <p className="text-gray-600 font-light leading-relaxed mb-6 text-base">
                Genießen Sie frisch zubereitete Pasta mit ausgewählten Premium-Zutaten. Unsere klassische Pasta-Bar bietet authentische italienische Geschmackserlebnisse mit höchster Qualität und Liebe zum Detail.
              </p>
              <div className="flex items-baseline mb-8">
                <span className="text-4xl font-serif text-amber-600">15,90 €</span>
                <span className="text-gray-500 font-light ml-2">pro Person</span>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-700 font-light text-sm">inkl. Vorspeisen und Dessertauswahl</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-700 font-light text-sm">Premium italienische Zutaten</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-700 font-light text-sm">Verschiedene Saucen zur Auswahl</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-700 font-light text-sm">Vegetarische Optionen</span>
                </li>
              </ul>
              <button 
                onClick={() => scrollToSection('cta')}
                className="w-full px-8 py-3.5 border-2 border-gray-900 text-gray-900 text-sm font-light tracking-wide hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap"
              >
                Jetzt anfragen
              </button>
            </div>
          </div>

          {/* Karte 2 */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group relative">
            <div className="absolute top-6 right-6 z-10">
              <span className="px-4 py-1.5 bg-amber-600 text-white text-xs font-light tracking-wider rounded-full whitespace-nowrap">
                HIGHLIGHT
              </span>
            </div>
            <div className="relative h-80 overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=chef%20performing%20live%20cooking%20tossing%20pasta%20inside%20giant%20parmesan%20cheese%20wheel%20dramatic%20flames%20and%20steam%20theatrical%20presentation%20luxury%20event%20catering%20dark%20moody%20cinematic%20lighting%20golden%20highlights%20exclusive%20dining%20experience%20professional%20culinary%20art&width=800&height=600&seq=offer002&orientation=landscape" 
                alt="Das Highlight: Live-Cooking" 
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent"></div>
            </div>
            <div className="p-10">
              <h3 className="font-serif text-3xl text-white mb-4 tracking-tight">
                Das Highlight: Live-Cooking
              </h3>
              <p className="text-gray-300 font-light leading-relaxed mb-6 text-base">
                Das ultimative Erlebnis: Erleben Sie, wie Ihre Pasta direkt vor Ihren Augen im riesigen Parmesanlaib geschwenkt wird. Ein unvergessliches kulinarisches Schauspiel für Ihre Gäste.
              </p>
              <div className="flex items-baseline mb-8">
                <span className="text-4xl font-serif text-amber-500">+ 9,90 €</span>
                <span className="text-gray-400 font-light ml-2">pro Person</span>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <i className="ri-star-fill text-amber-500 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-300 font-light text-sm">Live-Cooking Performance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-amber-500 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-300 font-light text-sm">Großes Parmesanlaib</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-amber-500 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-300 font-light text-sm">Interaktives Erlebnis</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-amber-500 text-lg mt-0.5 mr-3"></i>
                  <span className="text-gray-300 font-light text-sm">Unvergessliche Atmosphäre</span>
                </li>
              </ul>
              <button 
                onClick={() => scrollToSection('cta')}
                className="w-full px-8 py-3.5 bg-amber-600 text-white text-sm font-light tracking-wide hover:bg-amber-700 transition-all duration-300 rounded-md cursor-pointer whitespace-nowrap shadow-lg"
              >
                Jetzt Event anfragen
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
